import React, { useState, useEffect, useRef } from "react";
import "./Form.scss";
import img from "../../../Assets/Business/arrow.png";
import { IoMdClose } from "react-icons/io";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { track } from "../../../analytics";
import { Link } from "react-router-dom";
import { GoPaperclip } from "react-icons/go";

const Loader = () => (
  <>
    <style>{`
      @keyframes spin {
        to { transform: rotate(360deg); }
      }
      @keyframes pulse-ring {
        0%   { transform: scale(0.8); opacity: 1; }
        100% { transform: scale(2);   opacity: 0; }
      }
      @keyframes dot-bounce {
        0%, 80%, 100% { transform: translateY(0);    opacity: 0.3; }
        40%            { transform: translateY(-10px); opacity: 1;   }
      }
    `}</style>

    <div className="formLoader_overlay">
      <div className="formLoader_card">
        <div className="formLoader_spinner">
          <div className="formLoader_ring" />
          <div className="formLoader_arc" />
        </div>

        <div className="formLoader_text">
          <p className="formLoader_title">Отправляем заявку</p>
          <p className="formLoader_hint">Пожалуйста, подождите...</p>
        </div>

        <div className="formLoader_dots">
          {[0, 1, 2].map((i) => (
            <div
              key={i}
              className="formLoader_dot"
              style={{ animationDelay: `${i * 0.2}s` }}
            />
          ))}
        </div>
      </div>
    </div>
  </>
);

const BUSINESS_PATHS = ["/", "/cash", "/adminHome", "/adminHistory", "/adminTarifs", "/AdminServices"];

const ErrorMessage = ({ text }) => (
  <span className="field-error">
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
    {text}
  </span>
);

const Form = ({ setShowModal, show, id, endpoint, service_name }) => {
  const [activeFile, setActiveFile] = useState(false);
  const [fileName, setFileName] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("+992");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [showSeccesMessage, setShowSuccessMessage] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const location = useLocation();

  const isBusinessPath = BUSINESS_PATHS.includes(location.pathname);
  const showEmailField = !isBusinessPath;

  const validate = () => {
    let valid = true;

    const digits = phone.slice(4).replace(/\D/g, "");
    if (digits.length < 9) {
      setPhoneError(true);
      valid = false;
    }

    if (showEmailField) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!email.trim() || !emailRegex.test(email.trim())) {
        setEmailError(true);
        valid = false;
      }
    }

    return valid;
  };

  const addForm = () => {
    if (!validate()) return;

    setIsLoading(true);
    axios
      .post(`https://nets.tj/${endpoint}`, {
        name: name,
        phone: phone,
        interested_in: id,
        service_name: service_name,
        address: address,
        email: email,
      })
      .then(() => {
        setShowSuccessMessage(true);
        // в параметрах только имя формы и endpoint: ни телефона, ни почты
        track("lead_submit", { form: service_name || "form", endpoint });
      })
      .catch((err) => {
        console.log(err);
        track("lead_error", {
          form: service_name || "form",
          reason: err?.response?.status ? String(err.response.status) : "network",
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const formContainerRef = useRef(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) setFileName(file.name);
  };

  const handlePhoneChange = (e) => {
    let val = e.target.value;
    if (!val.startsWith("+992")) val = "+992";
    const digits = val.slice(4).replace(/\D/g, "").slice(0, 9);
    setPhone("+992" + digits);
    if (phoneError) setPhoneError(false);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    if (emailError) setEmailError(false);
  };

  const handleClickOutside = (event) => {
    if (formContainerRef.current && !formContainerRef.current.contains(event.target)) {}
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="form_container" ref={formContainerRef} id="form">
      {isLoading && <Loader />}

      <div className="form_block">
        {showSeccesMessage && (
          <div className="succes_block">
            <p>Ваше сообщение доставлено. Мы свяжемся с вами в течение 24 часов.</p>
          </div>
        )}
        {show && (
          <IoMdClose onClick={() => setShowModal(false)} className="formClose_icon" />
        )}
        {!showSeccesMessage && (
          <div className="form_item">
            <div className="form_title">
              <h3>Заявка</h3>
              <p>Оставьте данные для консультации и подключения</p>
            </div>
            <div className="form_data">
              <div className="formInput_block">
                <div className="formInput_item">
                  <p>Как вас зовут</p>
                  <p>Необязательно</p>
                </div>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>

              {isBusinessPath && location.pathname !== "/adminHome" &&
                location.pathname !== "/adminHistory" &&
                location.pathname !== "/adminTarifs" &&
                location.pathname !== "/AdminServices" && (
                <div className="formInput_block">
                  <div className="formInput_item">
                    <p>Ваш адрес</p>
                    <p>Необязательно</p>
                  </div>
                  <input
                    type="text"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                  />
                </div>
              )}

              {!isBusinessPath && (
                <div className="formInput_block">
                  <div className="formInput_item">
                    <p>Данные о юрлице или ИП</p>
                    <p>Необязательно</p>
                  </div>
                  <input type="text" />
                </div>
              )}

              <div className="formInputPhone_block">
                <div className="formInputPhone_item">
                  <div className="formInputPhone_label">
                    <p>Мобильный телефон</p>
                    <p className="required-badge">Обязательно</p>
                  </div>
                  <input
                    type="tel"
                    value={phone}
                    onChange={handlePhoneChange}
                    placeholder="+992 XXXXXXXXX"
                    maxLength={13}
                    className={phoneError ? "input-error" : ""}
                  />
                  {phoneError && (
                    <ErrorMessage text="Введите номер телефона в формате +992XXXXXXXXX" />
                  )}
                </div>

                {showEmailField && (
                  <div className="formInputPhone_item">
                    <div className="formInputPhone_label">
                      <p>Email для отправки документов</p>
                      <p className="required-badge">Обязательно</p>
                    </div>
                    <input
                      type="text"
                      value={email}
                      onChange={handleEmailChange}
                      placeholder="example@mail.com"
                      className={emailError ? "input-error" : ""}
                    />
                    {emailError && (
                      <ErrorMessage text="Введите корректный email адрес" />
                    )}
                  </div>
                )}
              </div>

              {!isBusinessPath && (
                <>
                  <button
                    type="button"
                    className="formArrowFile_block"
                    onClick={() => setActiveFile(!activeFile)}
                  >
                    <GoPaperclip aria-hidden="true" />
                    <h4>Добавить файлы</h4>
                  </button>
                  {activeFile && (
                    <div className="vacanciesItemFormFile_block">
                      <div className="vacanciesItemFormFile_item">
                        <div className="vacanciesItemFormFile">
                          <input type="file" id="file" onChange={handleFileChange} />
                          {!fileName && <p>Выберите файл <span>или переместите сюда</span></p>}
                          {fileName && <p>Выбран файл: {fileName}</p>}
                        </div>
                      </div>
                      <h5>Форматы файла: DOC, DOCX, PDF. Не более 5 МБ</h5>
                    </div>
                  )}
                </>
              )}

              <div className="formBtn_block">
                <p>
                  Нажимая кнопку «Оставить заявку», вы соглашаетесь c{" "}
                  <span>
                    <Link
                      to="/oferta"
                      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                      className="oferta-link"
                    >
                      публичной офертой
                    </Link>
                  </span>
                </p>
                <div
                  className="formBtn_item"
                  onClick={() => !isLoading && addForm()}
                >
                  <button type="button" className="formBtn_submit">
                    Оставить заявку
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Form;